import React, { Component } from 'react'
import { Redirect } from 'react-router-dom'

import * as roles from './shared/javascripts/helpers/userRoles';

class HomePage extends Component {
  render() {
    const dashboardPath = roles._findUserDashboardPath(this.props.currentUser.attributes)
    return <Redirect to={dashboardPath} />
  }
}

export default HomePage;


// WEBPACK FOOTER //
// ./src/HomePage.jsx